<template>
  <div class="login">
    <div class="login-cointainer">
      <h2>为确保认证顺利进行</h2>
      <h3>请仔细阅读以下注意事项</h3>
      <img :src="img" alt class="de_head-img" v-if="upload" />
      <img :src="head_img" alt class="de_head-img" v-else />
      <div class="result_info">
        <div class="result_info_item">
          <img
            src="@/assets/result_head_left.png"
            alt
            class="result_info_item_img"
          />

          <span>
            <img :src="warn" class="result_info_item_warn" alt />遮挡脸部
          </span>
        </div>
        <div class="result_info_item">
          <img
            src="@/assets/result_head.png"
            alt
            class="result_info_item_img big_img"
          />
          <span>
            <img :src="warn" class="result_info_item_warn" alt />没有入镜
          </span>
        </div>
        <div class="result_info_item">
          <img
            src="@/assets/result_head_right.png"
            alt
            class="result_info_item_img"
          />
          <span>
            <img :src="warn" class="result_info_item_warn" alt />光线不足
          </span>
        </div>
      </div>
      <input
        class="hide_file"
        ref="leftFile"
        id="upload"
        type="file"
        @change="getFile($event)"
        accept="image/*"
      />
      <div class="su_btn_footer">
        <div
          class="su_btn_footer_choose su_btn_footer_choose_color"
          @click="clickFile"
        >
          <span>进行认证</span>
          <span>使用摄像头</span>
        </div>
      </div>
    </div>
    <van-popup
      class="login_opt"
      :close-on-click-overlay="false"
      v-model="show"
      round
      position="bottom"
      :style="{ height: '20%' }"
    >
      <h4 class="login_opt_title">
        拍摄已完成
        <span style="color: #f41b5d; margin: 0 5px"></span>
      </h4>
      <div>
        <div class="login_opt_confirm login_opt_btn" @click="handleSub">
          <span>确认提交</span>
        </div>

        <div class="login_opt_cancel login_opt_btn" @click="clickFile">
          重新拍摄
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import CommonTitle from "@/components/CommonTitle/Index";
import NotFound from "@/components/Notfound";
import next from "@/assets/next.png";
import login_bg from "@/assets/login_bg.png";
import img from "@/assets/de_head.png";
import warn from "@/assets/warn.png";
import axios from "axios";
import { Toast } from "vant";
import { getCheckImg } from "@/api/attest";
const baseUrl = process.env.NODE_ENV === "production" ? "/app" : "/api";

export default {
  components: { CommonTitle, NotFound },
  data() {
    this.img = img;
    this.baseUrl = baseUrl;
    this.next = next;
    this.login_bg = login_bg;
    this.warn = warn;
    return {
      wxData: {},
      serverIds: "",
      url: "",
      phone: "",
      type: 1,
      userInfo: JSON.parse(sessionStorage.getItem("user_info")),
      image: "",
      show: false,
      upload: true,
      head_img: "",
      registerCode: "",
      password: "",
      imgSrc: "", //展示的图片路径
      tupianlist: "", //展示的图片容器
    };
  },
  methods: {
    // 获取选择的图片文件上传
    getFile(e) {
      this.show = false;
      let file = e.target.files[0];
      // let param = new FormData(); //创建form对象
      // param.append("file", file, file.name); //通过append向form对象添加数据
      this.blobToBase64(file,file.name)
      // param.append("module", "module");
      
    },
    uploadImg(blob){
      let config = {
        headers: {
          Authorization: "Bearer " + window.localStorage.getItem("gl_token"),
          "Content-Type": "multipart/form-data",
        },
      }; //添加请求头
      axios.post(`${this.baseUrl}/uploadFile`, blob, config).then((res) => {
        if (res.data.code == 200) {
          this.head_img = res.data.data;
          this.upload = false;
          this.show = true;
        } else if (res.data.status == 2) {
          this.$toast(res.data.message);
        }
      });
    },
    /**
     * 获取到的二进制文件 转 base64文件
     * @param blob
     */
    blobToBase64(blob,type) {
      const self = this; // 绑定this
      const reader = new FileReader(); //实例化一个reader文件
      reader.readAsDataURL(blob); // 添加二进制文件
      reader.onload = function (event) {
        const base64 = event.target.result; // 获取到它的base64文件
        const scale = 0.8; // 设置缩放比例 （0-1）
        self.compressImg(base64, scale,type,self.uploadImg); // 调用压缩方法
      };
    },
    /**
     * 压缩图片方法
     * @param base64  ----baser64文件
     * @param scale ----压缩比例 画面质量0-9，数字越小文件越小画质越差
     * @param callback ---回调函数
     */
    compressImg(base64, scale,type,callback) {
      // 处理缩放，转换格式
      // 下面的注释就不写了，就是new 一个图片，用canvas来压缩
      const img = new Image();
      img.src = base64;
      img.onload = function () {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        canvas.setAttribute("width", this.width);
        canvas.setAttribute("height", this.height);
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        // 转成base64 文件
        let base64 = canvas.toDataURL("image/jpeg");
        // 根据自己需求填写大小 
        while (base64.length > 1024 * 1024 * 2) {
          scale -= 0.01;
          base64 = canvas.toDataURL("image/jpeg", scale);
        }
        // baser64 TO blob 
        const arr = base64.split(",");
        const mime = arr[0].match(/:(.*?);/)[1];
        const bytes = atob(arr[1]);
        const bytesLength = bytes.length;
        const u8arr = new Uint8Array(bytesLength);
        for (let i = 0; i < bytes.length; i++) {
          u8arr[i] = bytes.charCodeAt(i);
        }
        const blob = new Blob([u8arr], { type: mime });
        // 回调函数 根据需求返回二进制数据或者base64数据，我的项目都给返回了
        const fd = new FormData();
        fd.append('file',blob,type)
        callback(fd);
        // return blob
      };
    },
    // 点击触发input的点击事件
    clickFile() {
      this.$refs.leftFile.click();
    },

    handleSub() {
      Toast.loading({
        message: "上传中...",
        duration: 0, // 持续展示 toast
        forbidClick: true,
      });

      getCheckImg({
        img: this.head_img,
        applyId: this.$route.query.aId,
        settingId: this.$route.query.sId,
      })
        .then((res) => {
          if (res.code == 200) {
            Toast.success(res.message);
            this.$router.push("/success");
          } else {
            this.$router.push("/error");
          }
        })
        .catch(() => {
          this.$router.push("/error");
        });
    },
  },
};
</script>
<style lang="less" scoped>
.login {
  width: 100%;
  height: 100%;
  .hide_file {
    display: none;
  }
  &-cointainer {
    padding-top: 20px;
    text-align: center;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #000000;
    > h2 {
      margin-bottom: 10px;
    }
    .de_head-img {
      margin: 30px 0 40px;
      width: 222px;
      height: 240px;
    }
    .result_info {
      display: flex;
      width: 250px;
      margin: 0 auto;
      justify-content: space-between;
      align-items: flex-end;
      &_item {
        display: flex;
        align-items: center;
        flex-direction: column;
        &_warn {
          width: 10px;
          height: 10px;
          margin-right: 2px;
        }
        > span {
          font-size: 14px;
          margin-top: 8px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #a9a9a9;
        }
      }
      &_item_img {
        width: 42px;
        height: 50px;
        margin-bottom: 4px;
      }
      .big_img {
        width: 48px;
        height: 56px;
      }
    }
    .su_btn_footer {
      padding: 0 14px;
      position: fixed;
      left: 0;
      bottom: 50px;
      width: 100%;
      &_choose {
        width: 100%;
        height: 60px;
        padding: 5px 0px;
        background: #2c66f8;
        border-radius: 3px;
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        > span:last-child {
          font-size: 14px;
          opacity: 0.5;
        }
        &_color {
          background-color: #2c66f8;
        }
      }
    }
  }
  &_opt {
    text-align: center;
    &_title {
      font-size: @m-font-size;
      padding: 20px 20px;
    }
    &_btn {
      width: 126px;
      height: 44px;
      line-height: 44px;
      font-size: @s-font-size;
      border-radius: 22px;
      display: inline-block;
    }
    &_confirm {
      background: @blue;
      color: @white;
    }
    &_cancel {
      border: 1px solid @grey;
      margin-left: 30px;
    }
  }
}
</style>
